function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M92 115C142.81 115 184 106.057 184 95.0244C184 83.9922 142.81 75.0488 92 75.0488C41.1898 75.0488 0 83.9922 0 95.0244C0 106.057 41.1898 115 92 115Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#D9D9D9",
  d: "M158.125 37.2662L128.955 4.44342C127.555 2.20615 125.511 0.853516 123.358 0.853516H60.6424C58.489 0.853516 56.4449 2.20615 55.0447 4.44056L25.875 37.2691V63.634H158.125V37.2662Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAFAFA",
  stroke: "#D9D9D9",
  d: "M119.637 46.3152C119.637 41.7351 122.495 37.954 126.04 37.9512H158.125V89.708C158.125 95.7663 154.33 100.732 149.644 100.732H34.3562C29.67 100.732 25.875 95.7634 25.875 89.708V37.9512H57.96C61.5049 37.9512 64.3626 41.7266 64.3626 46.3067V46.3695C64.3626 50.9496 67.252 54.6479 70.794 54.6479H113.206C116.748 54.6479 119.637 50.9153 119.637 46.3352V46.3152Z"
});

var SvgEmpty = function SvgEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 184 115",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty.735cb4f5.svg";
export { ForwardRef as ReactComponent };